export default "__VITE_ASSET__BFX0YJKz__"